import(/* webpackMode: "eager" */ "/vercel/path0/app/(static)/terms/page.tsx");
